<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
        <el-container style="height:500px;margin-right:10px">
          <el-aside border="1px" class="consumeInfo"  style="border:1px"> 
            <div>              
              <el-row>             
                <el-col>
                  <div class="memberHeader">
                    <div class="image">
                      <el-avatar :size="80"  src="" @error="errorHandler">
                        <img :src="member.imageUrl"/>
                      </el-avatar>
                    </div>
                    <div class="info left5">
                      <p class="top10">{{member.name}}({{member.vipState}})</p>
                      <p>积分：{{member.point}}</p>
                      <p>储值：{{member.value}}</p>
                      <p>奖励：{{member.reward}}</p>
                    </div>
                    <div class="operation">
                      <el-button class="top10"  type="primary" v-on:click="readMember" v-if="memberLogin==false" >会员登陆</el-button>
                      <el-button class="top10" type="success" v-on:click="resetMember" v-if="memberLogin==true" >退出登陆</el-button>
                    </div>
                  </div>
                </el-col>
              </el-row> 
            </div> 
            <div>              
              <el-row>     
                <el-col :span="24" style="height:330px">
                  <el-card v-for="(item,index) in buyProducts"  :key="index" :body-style="{ padding: '5px' }">
                    <div class="selectProduct">
                      <div class="info">
                        <p>{{item.Name}}</p>
                        <p>￥{{  item.PreferentialFee}}</p>
                      </div>
                      <div class="number">
                        <span class="el-icon-circle-plus-outline" @click="add(item)"></span>
                        <span> {{item.Number}} </span>
                        <span class="el-icon-remove-outline" @click="deduct(item)"></span>
                      </div>
                    </div>
                  </el-card>
                </el-col>     
              </el-row>
            </div>   
            <div>                
              <el-row class="top10 center"  >  
                <el-button type="success" @click="checkOut" >结 账{{ReceiptAmount}}元 </el-button>            
              </el-row>            
            </div>               
          </el-aside>
          <el-container>
            <el-main v-model="consume" style="padding:10px">
              <el-form :inline="true" @submit.native.prevent>    
                <el-form-item >
                  <el-input  
                    placeholder="商品编码" 
                    v-model="search.barcode"
                    @keyup.enter.native="Query">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" v-on:click="Query" >查询</el-button>
                </el-form-item>
                <el-form-item >
                  <el-button  icon="el-icon-edit">介绍人</el-button>
                </el-form-item>
              </el-form>
              <el-form label-width="100px" style="margin-top:-10px">   
                <el-divider style="margin:5px"></el-divider>
                <el-tabs v-model="search.categoryId" @tab-click="handleClick">
                  <el-tab-pane label="全部"  name=""></el-tab-pane>                  
                  <el-tab-pane v-for="(item,id) in categorys" :key="id" :label="item.name" :name="item.id"></el-tab-pane>
                </el-tabs>
                <el-row :gutter="5">
                  <el-col :span="8" v-for="(item,Index) in products" :key="Index" >
                    <el-card >
                      <div class="product">
                        <div class="productImage left5">
                          <img :src="item.Icon" class="image">
                        </div>
                        <div class="productInfo">
                          <p class="title">{{item.Name}}</p>
                          <p class="vipPrice">￥:{{item.Price}}</p>
                          <p class="price">原价:{{item.OriginalPrice}}</p>
                          <span class="icon-plus add" @click="add(item)"></span>
                        </div>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
                <el-pagination
                  :hide-on-single-page="true"
                  @current-change="handleCurrentChange"
                  :current-page="search.pageIndex"
                  :page-size="search.pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="search.totalCount">
                </el-pagination>
              </el-form>   
            </el-main>
          </el-container>
        </el-container>
        
      <GetMember v-bind:dialogMember="dialogMember" @UpdateMember="UpdateMember"></GetMember>
      <Checkout v-bind:dialogCheckout="dialogCheckout" @UpdatedCheckout="UpdatedCheckout"></Checkout>
    </section>  
  </section>  
</template>
<script  type='text/ecmascript-6'>
  import GetMember from '@/components/GetMember'
  import Checkout from '@/components/Checkout'
  import {accAdd} from '@/utils/index.js'
  import qs from 'qs' 
  export default {
    props:{
    },
    data (){
      return {
        member:{},
        consume:{},
        memberLogin:false,
        categorys:[],
        products:[],
        buyProducts:[],
        dialogMember: {
          title: '',
          isShow:false
        },
        dialogCheckout: {
          isShow:false
        },
        search:{
          totalCount:0,
          pageIndex:1,
          PageSize:9,
          merchantId:'',
          categoryId:'',
          barcode:'',
          StoreDisplay: 1,
          Sort: ' id desc'
        }
      }
    },
    components:{
      GetMember,
      Checkout
    },
    computed:{
      ProductAmount:function(){       
        var price=0
        for(const i in this.buyProducts){
          price =accAdd(price, this.buyProducts[i].OriginalPrice * this.buyProducts[i].Number)
        }
        return price.toFixed(2)        
      },
      PreferentialFee:function(){
        // if(this.memberLogin){
        //   var price=0
        //   for(const i in this.buyProducts){
        //     price =accAdd(price, ( this.buyProducts[i].OriginalPrice - this.buyProducts[i].PreferentialFee) * this.buyProducts[i].Number)
        //   }
        // return price.toFixed(2)
        // }else {
        //   return 0;
        // }
        var price=0
        for(const i in this.buyProducts){
          price =accAdd(price, ( this.buyProducts[i].OriginalPrice - this.buyProducts[i].PreferentialFee) * this.buyProducts[i].Number)
        }
         return price.toFixed(2)
      },
      ReceiptAmount:function(){
        return this.ProductAmount - this.PreferentialFee
      }
    },
    mounted(){   
      var user = this.$cookie.getJSON('user')
      this.search.merchantId = user.merchantId
      this.resetMember()
      this.resetConsume()
      this.GetData()
      this.GetProduct()
    },
    methods:{  
      GetData:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Comsune/ProductConsumeGet',
          data:{
            merchantId: that.search.merchantId
          }       
        }).then(function (resp) {
          that.categorys = resp.data.result.categorys
          that.payWay = resp.data.result.payWay
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      GetProduct:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Product/Index',
          params:that.search
        }).then(function (resp) {
          that.products = resp.data.products
          that.search.totalCount = resp.data.totalCount 
          if(that.products.length==1 && that.search.barcode !='')
            that.add(that.products[0])   
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      resetMember(){
        this.member ={
          id:0,
          number:'',
          name:'游客',
          mobile:'',
          point:0,
          reward:0,
          value:0,
          isNormalVip:false,
          vipState:'',
          imageUrl:'',
          gender:'未知'
        }
        this.memberLogin = false
      },
      readMember(){
        this.dialogMember.isShow = true
      },
      UpdateMember(obj){
        this.member = obj
        this.memberLogin = true
      },
      resetConsume(){
        this.consume={         

        }
      },
      errorHandler(){
        return true;
      },      
      Query(){
        this.search.pageIndex = 1
        this.GetProduct(this.products)
      },
      handleClick(){
        this.search.pageIndex = 1 
        this.GetProduct()
      },
      handleCurrentChange(index){

      },
      add(row){
        var isExit = false
        for(const i in this.buyProducts){
          if(this.buyProducts[i].Id==row.Id){
            isExit = true
            this.$set(this.buyProducts[i],'Number',this.buyProducts[i].Number+1)
            break
          }
        }
        if(isExit==false){
          var pro= {
            Id : row.Id,
            Name : row.Name,
            Image: row.Icon,
            PreferentialFee : row.Price,
            OriginalPrice : row.OriginalPrice,
            Number : 1,
            ItemId : row.Id
          }
          this.buyProducts.push(pro)
        }
        // this.$forceUpdate() 
      }, 
      deduct(row){
         for(const i in this.buyProducts){
          if(this.buyProducts[i].Id==row.Id){
            if(this.buyProducts[i].Number>1)
              this.$set(this.buyProducts[i],'Number',this.buyProducts[i].Number-1);
            else
              this.buyProducts.splice(i,1)
            break
          }
        }

      },      
      UpdatedCheckout(info){    
        var user = this.$cookie.getJSON('user')
        this.consume.PaidInfo = info
        this.consume.chainStoreId = user.chainStoreId
        this.consume.merchantId = user.merchantId
        this.consume.memberId = this.member.id
        this.consume.password = info.Password
        //this.consume.shareMemberNo = info.shareMemberNo
        this.consume.items = JSON.stringify(this.buyProducts)
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Comsune/ProductConsume',         
          data:that.consume
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
            that.resetMember()
            that.resetConsume()
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      checkOut(){
        this.dialogCheckout.member = this.member
        this.dialogCheckout.ReceivableAmount = this.ProductAmount
        this.dialogCheckout.ProductAmount = this.ProductAmount 
        this.dialogCheckout.ReceiptAmount = this.ReceiptAmount
        this.dialogCheckout.PreferentialFee = this.PreferentialFee
        this.dialogCheckout.memberLogin = this.memberLogin
        this.dialogCheckout.title = '应收金额'+ this.dialogCheckout.ReceiptAmount 
        this.dialogCheckout.isShow = true
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-aside 
  background-color: #D3DCE6;
  color: #333;  
.el-main 
  background-color: #E9EEF3;
  color: #333;
.center
  text-align center
.top10
  margin-top 10px;
.left5
  padding-left 5px;
.memberHeader
  display:flex;
  algin-items:center;
  just-content:space-between;
  .image
    flex 1
  .info
    flex 1
  .operation
    flex 1

.product
  display:flex;
  algin-items:center;
  just-content:space-between;
  .productImage
    width 100px;
    order 0;
    img
      width 100px
      height 100px
  .productInfo
    min-width:0;
    flex:1
    margin-left 3px
    .title
      height 40px
      overflow: hidden;  // 超出的文本隐藏
      text-overflow: ellipsis; // 溢出用省略号显示
      white-space: nowrap; // 溢出不换行
      display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示。
      -webkit-line-clamp: 2; // 这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。
      -webkit-box-orient: vertical;  // 从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
    .vipPrice
      color #ff4d4d
      font-weight 600
      font-size 14px
      text-align: right 
    .price
      margin-top 3px
      font-weight 400
      font-size 12px
    .add
      float right
      bottun 5px
      right 5px
.selectProduct
  display:flex;
  algin-items:center;
  just-content:space-between;
  .info
    flex :1
  .number
    width 60px
    span 
      height 35px
      line-height 35px
      font-size 16px

.el-divider--horizontal{
  margin: 5px;
}
</style>